// scheme链接前缀
const SCHEME_MACHPRO_WITH_PRE = 'sailorc://keeta.com/machpro'

export { SCHEME_MACHPRO_WITH_PRE }
